import './DateCell.css';
export default {
    "compactDateCell": "DateCell_compactDateCell__h4alf",
    "timeSlot": "DateCell_timeSlot__h4alf",
    "selectedCell": "DateCell_selectedCell__h4alf",
    "disabledCell": "DateCell_disabledCell__h4alf",
    "todayCell": "DateCell_todayCell__h4alf",
    "compactSignalIcons": "DateCell_compactSignalIcons__h4alf",
    "selectedCellForStories": "DateCell_selectedCellForStories__h4alf",
    "soldOutCell": "DateCell_soldOutCell__h4alf",
    "discountCell": "DateCell_discountCell__h4alf",
    "highDemandCell": "DateCell_highDemandCell__h4alf",
    "rebrandedCell": "DateCell_rebrandedCell__h4alf",
    "soldOutCellRebranded": "DateCell_soldOutCellRebranded__h4alf",
    "discountCellRebranded": "DateCell_discountCellRebranded__h4alf",
    "highDemandCellRebranded": "DateCell_highDemandCellRebranded__h4alf",
    "disabledCellRebranded": "DateCell_disabledCellRebranded__h4alf",
    "selectedCellRebranded": "DateCell_selectedCellRebranded__h4alf",
    "todayCellRebranded": "DateCell_todayCellRebranded__h4alf",
    "dateText": "DateCell_dateText__h4alf"
};
